import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectProjectActivityFromDate,
  selectProjectActivityToDate,
  selectSelectedProject,
} from '../selectors/projectsSelectors';
import { getProjectActivityInformationInTimeframe } from '../services/getProjectActivityInformationInTimeframe.service';

export const loadProjectsActivityInformationIntimeframe = createAsyncThunk(
  'projects/loadProjectsActivityInformationIntimeframe',
  async (_, { getState }) => {
    const selectedProject = selectSelectedProject(getState());

    const projectActivityFromDate = selectProjectActivityFromDate(getState());

    const projectActivityToDate = selectProjectActivityToDate(getState());

    const projectActivityData = await getProjectActivityInformationInTimeframe({
      businessId: selectedProject.business_id,
      fromDate: projectActivityFromDate,
      toDate: projectActivityToDate,
    });

    return projectActivityData;
  }
);
